module.exports = __webpack_public_path__ + "6fe22653396dcd45b7096c1e655d174d.jpg";